import { Box, Flex, Text } from '@chakra-ui/layout';
import CardMy from 'components/CardMy';
import Title from 'components/CardMy/Title';
import Label from 'components/Label';
import BarChart from 'components/charts/BarChart';
import { HiLightningBolt } from 'react-icons/hi';
import { barChartDataConsumption, barChartOptionsConsumption } from 'variables/charts';

import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { IconButton } from '@chakra-ui/button';

const DailyActivity = () => (
    <CardMy>
        <Flex flexWrap="wrap" justifyContent="space-between" alignItems="center" w="100%" mb="26px">
            <Title icon={HiLightningBolt}>Daily Activity</Title>
            <Flex gap="16px">
                {barChartDataConsumption.map((item, index) => (
                    <Label text={item.name} color={barChartOptionsConsumption.colors[index]} key={index} />
                ))}
            </Flex>
        </Flex>
        <Flex flexWrap="wrap" justifyContent="space-between" alignItems="center" w="100%">
            <Text color="gray.900" fontSize="32px" fontWeight={700} letterSpacing="-0.96px" lineHeight={1}>
                4.5 hours
                <Text as="span" color="gray.500" fontWeight="500" fontSize="14px" ml="8px">
                    Average RGAT
                </Text>
            </Text>
            <Flex gap="8px">
                <IconButton
                    isRound={true}
                    aria-label="prev"
                    borderWidth="1px"
                    borderColor="gray.200"
                    bg="white"
                    fontSize="20px"
                    icon={<IoChevronBack />}
                />
                <IconButton
                    isRound={true}
                    aria-label="next"
                    borderWidth="1px"
                    borderColor="gray.200"
                    bg="white"
                    fontSize="20px"
                    icon={<IoChevronForward />}
                />
            </Flex>
        </Flex>

        <Box h="282px" w="100%">
            <BarChart chartData={barChartDataConsumption} chartOptions={barChartOptionsConsumption} />
        </Box>
    </CardMy>
);

export default DailyActivity;
